import { render, staticRenderFns } from "./UsuarioFormModal.vue?vue&type=template&id=4c2bc3de"
import script from "./UsuarioFormModal.vue?vue&type=script&lang=js"
export * from "./UsuarioFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports